import React, { useEffect } from 'react';
import { FieldCheckbox } from '..';
import { IconAnonymousL } from '../../icons';
import css from './BlockAnonymousListing.css';

const fieldName = 'applyAnonymity';

export default ({ currentUserIsOwner, form, publicUserName, disabled: disabledProp }) => {
    useEffect(() => {
        /** applyAnonymity is true by default */
        form.change(fieldName, true);
    }, []);

    return (
        <div className={css.root}>
            <div className={css.icon}>
                <IconAnonymousL />
            </div>
            <div className={css.heading}>
                <p>Anonymes {currentUserIsOwner ? 'Profil' : 'Profil'}</p>
                <FieldCheckbox
                    type="checkbox"
                    id={fieldName}
                    name={fieldName}
                    form={form}
                    className={css.toggler}
                    disabled={disabledProp}
                    togglerMode
                />
            </div>
            <p className={css.teaser}>Aus Zusatzpaket</p>
            <p className={css.description}>
                Namen, Fotos und Videos bleiben für {publicUserName} bis zu einem Match verborgen.{' '}
                <a
                    href="https://support.horsedeal.com/hc/de/articles/27387130476050"
                    target="_blank"
                    rel="nofollow"
                >
                    Mehr erfahren
                </a>
            </p>
            <div className={css.footer}>
                <div className={css.badge}>Neu</div>
            </div>
        </div>
    );
};
